<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'artikel', 'suche']">
          <i class="fa fa-cube"></i>
          Artikel
        </a>
      </li>
      <li>Wareneingang</li>
    </ul>
  </div>
</div>
<div class="page-content page-frame overflow-y-auto">
  <form
    [formGroup]="articleForm"
    (submit)="createOrUpdateArticle()"
    class="page-sheet max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2"
  >
    <div class="bm-card bm-card-sm">
      <div class="bm-card-body">
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Typ *</label>
          <ng-select
            class="w-full"
            [items]="templates"
            bindLabel="description"
            bindValue="id"
            formControlName="template_id"
            [loading]="loadingTemplates"
            [virtualScroll]="true"
            [required]="true"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.description }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
              @if (!searchTerm || item.description.toLowerCase().includes(searchTerm.toLowerCase())) {
                {{ item.description }}
              }
            </ng-template>
          </ng-select>

          <label class="bm-fieldset-label">Seriennummer</label>
          <input class="bm-input w-full" type="text" formControlName="serial_number" />
          <p>Mit Tippen beginnen, um Vorschläge anzeigen zu lassen. Es sind nur Typen aus der Liste gültig.</p>

          @if (showRfidFields) {
            <!-- RFID-Etikett (bentomax/hawk#605) -->
            <label class="bm-fieldset-label">XID</label>
            @if (existingXid) {
              <span class="font-mono">{{ existingXid }}</span>
              <small class="text-base-content/70">Ändern über „Umschlüsseln" auf der Artikelseite.</small>
            } @else {
              <input
                class="bm-input w-full font-mono"
                type="text"
                formControlName="xid"
                placeholder="XID-0101010"
                autocomplete="off"
                (blur)="normalizeXidInput()"
                [class.bm-input-error]="articleForm.errors?.['xidInvalid']"
              />
              @if (articleForm.errors?.["xidInvalid"]) {
                <small class="text-error">Ungültige XID. Erwartet wird XID-NNNNNNN (7 Ziffern) oder ein Bentomax-EPC.</small>
              }
            }

            <label class="bm-fieldset-label">Lagerort{{ articleForm.get("xid")?.value && !existingXid ? " *" : "" }}</label>
            <input
              class="bm-input w-full"
              type="text"
              formControlName="shelf_label"
              (blur)="normalizeShelfLabelInput()"
              placeholder="z. B. A5010"
              [class.bm-input-error]="articleForm.errors?.['shelfLabelRequired']"
            />
            @if (articleForm.errors?.["shelfLabelRequired"]) {
              <small class="text-error">Zur XID gehört immer ein Lagerort-Label.</small>
            }
          }

          <label class="bm-fieldset-label">MAC Adresse</label>
          <input
            class="bm-input w-full"
            type="text"
            formControlName="mac_address"
            placeholder="XX:XX:XX:XX:XX:XX oder XX-XX-XX-XX-XX-XX"
            [class.border-red-500]="articleForm.get('mac_address')?.errors && articleForm.get('mac_address')?.touched"
          />
          @if (articleForm.get("mac_address")?.errors?.["macAddress"] && articleForm.get("mac_address")?.touched) {
            <small class="text-red-500">{{ articleForm.get("mac_address")?.errors?.["macAddress"]?.message }}</small>
          }

          <label class="bm-fieldset-label">Status</label>
          <ng-select
            class="w-full"
            [items]="statusesList"
            bindLabel="name"
            bindValue="id"
            formControlName="status"
            placeholder="Status"
            [clearable]="false"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
              @if (!searchTerm || item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                {{ item.name }}
              }
            </ng-template>
          </ng-select>

          <label class="bm-fieldset-label">Besitzer</label>
          <label class="bm-fieldset-label">
            <input class="bm-radio" type="radio" id="radioValueTrue" value="BENTOMAX" formControlName="owner" />
            Bentomax GmbH
          </label>
          <label class="bm-fieldset-label">
            <input class="bm-radio" type="radio" id="radioValueFalse" value="CUSTOMER" formControlName="owner" />
            Kunde:
          </label>
          <ng-select
            class="w-full"
            [items]="customers"
            bindLabel="name"
            bindValue="id"
            formControlName="owner_customer_id"
            placeholder="Kunde"
            [loading]="loadingCustomers"
            [virtualScroll]="true"
            (scrollToEnd)="fetchMoreCustomers()"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
              @if (!searchTerm || item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                {{ item.name }}
              }
            </ng-template>
          </ng-select>

          <label class="bm-fieldset-label">Lager *</label>
          <ng-select
            class="w-full"
            [items]="warehouses"
            bindLabel="name"
            bindValue="id"
            formControlName="warehouse_id"
            placeholder="Lager"
            [loading]="loadingWarehouses"
            [virtualScroll]="true"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.label }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
              @if (!searchTerm || item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
                <div>
                  {{ item.label }}
                </div>
              }
            </ng-template>
          </ng-select>

          <label class="bm-fieldset-label">Platz *</label>
          <ng-select
            class="w-full"
            [items]="bins"
            bindLabel="label"
            bindValue="id"
            formControlName="bin_id"
            placeholder="Platz"
            [loading]="loadingBins"
            [virtualScroll]="true"
            (scrollToEnd)="fetchMoreBins()"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.label }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
              @if (!searchTerm || item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
                {{ item.label }}
              }
            </ng-template>
          </ng-select>

          <label class="bm-fieldset-label">
            <input class="bm-checkbox" type="checkbox" formControlName="is_full" />
            Platz anschließend als voll markieren
          </label>
        </fieldset>
      </div>
    </div>
    <div class="bm-card bm-card-sm">
      <div class="bm-card-body">
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">
            <input
              class="bm-radio"
              type="radio"
              id="radioValueSupplierSupplier"
              value="supplier"
              formControlName="supplier"
            />
            Auswahl Lieferant
          </label>
          <ng-select
            class="w-full"
            [items]="suppliers"
            bindLabel="name"
            bindValue="id"
            formControlName="supplier_id"
            placeholder="Supplier"
            [loading]="loadingSuppliers"
            [virtualScroll]="true"
            (scrollToEnd)="fetchMoreSuppliers()"
          >
            <ng-template ng-label-tmp let-item="item">
              {{ item.name }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTermStatus">
              @if (!searchTerm || item.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                {{ item.name }}
              }
            </ng-template>
          </ng-select>

          <label class="bm-fieldset-label">
            <input
              class="bm-radio"
              type="radio"
              id="radioValueSupplierOther"
              value="other"
              formControlName="supplier"
            />
            Anderer
          </label>
          <input class="bm-input w-full" type="text" placeholder="Anderer" formControlName="supplier_other" />

          <label class="bm-fieldset-label"> Lieferscheinnummer (extern) </label>
          <input class="bm-input w-full" type="text" placeholder="Breite" formControlName="ext_delivery_note_number" />

          <label class="bm-fieldset-label"> Kaufdatum </label>
          <div class="bm-join">
            <input
              class="w-full bm-input bm-join-item"
              [matDatepicker]="purchase_date_picker"
              formControlName="purchase_date_picker"
              placeholder="Datum"
            />
            <mat-datepicker #purchase_date_picker />
            <button
              class="bm-btn bm-join-item"
              (click)="
                purchase_date_picker.opened ? purchase_date_picker.close() : purchase_date_picker.open(); (false)
              "
            >
              <span class="fa fa-calendar"></span>
            </button>
          </div>

          <label class="bm-fieldset-label"> Lieferdatum * </label>
          <div class="bm-join">
            <input
              class="w-full bm-input bm-join-item"
              [matDatepicker]="delivery_date_picker"
              formControlName="delivery_date"
              placeholder="Datum"
            />
            <mat-datepicker #delivery_date_picker />
            <button
              class="bm-btn bm-join-item"
              (click)="
                delivery_date_picker.opened ? delivery_date_picker.close() : delivery_date_picker.open(); (false)
              "
            >
              <span class="fa fa-calendar"></span>
            </button>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="flex flex-row justify-end gap-2 md:col-span-2">
      <a class="bm-btn" [routerLink]="['/', 'artikel', 'suche']"> Abbrechen </a>
      <button
        [disabled]="!formLoaded || articleForm.invalid || submittingArticle"
        class="bm-btn bm-btn-primary"
        type="submit"
      >
        Speichern
      </button>
    </div>
  </form>
</div>
